var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0851",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.333 24 24 26.666l5.333-5.333m0-8H2.667M29.333 16v-5.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H16"
  })));
};
export default SvgCheck;